import { Component, OnInit, AfterViewInit, ChangeDetectorRef, OnDestroy } from '@angular/core';
import { NavService } from '../../service/nav.service';
import { trigger, transition, useAnimation } from '@angular/animations';
import { fadeIn } from 'ng-animate';
import { HomeMemoryProbeService } from '../../service/home-memory-probe.service';

@Component({
  selector: 'app-content-layout',
  templateUrl: './content-layout.component.html',
  styleUrls: ['./content-layout.component.scss'],
  animations: [
    trigger('animateRoute', [
      transition('* => *', useAnimation(fadeIn))
    ])
  ]
})
export class ContentLayoutComponent implements OnInit, AfterViewInit, OnDestroy {

  public layoutType: string = 'RTL';
  public layoutClass: boolean = false;
  public routerOutletState: any;
  public disableAnims = false;

  constructor(
    public navServices: NavService,
  private cdr: ChangeDetectorRef,
  private homeProbe: HomeMemoryProbeService
  ) { }

  // Eliminado uso de función en plantilla que programaba timeouts por ciclo

  public clickRtl(val) {
    if (val === 'RTL') {
      document.body.className = 'rtl';
      this.layoutClass = true;
      this.layoutType = 'LTR';
    } else {
      document.body.className = '';
      this.layoutClass = false;
      this.layoutType = 'RTL';
    }
  }

  ngOnInit() { 
    // Inicializar estado del router
    this.routerOutletState = '';
  // Rehabilitar animaciones en todos los navegadores (incluido Safari)
  this.disableAnims = false;
  // Iniciar probe global de Home cuando esté habilitado (?mem=1 o localStorage.HOME_PROBE='1')
  try { this.homeProbe.start(15000); } catch {}
  }

  ngAfterViewInit() {
    // Detectar cambios después de que la vista esté inicializada
    this.cdr.detectChanges();
  }

  ngOnDestroy(): void {
    try { this.homeProbe.stop(); } catch {}
  }

}
